import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { fetchDownloadContents as fetchDownloadContentsAction } from '../actions/download.actions';
import MyDownloads from '../components/MyDownloads';
import { selectDownloadedItems, selectDownloadStatus } from '../reducers/download.selectors';
import { selectUser } from '../reducers/user.selectors';
import useAction from '../utils/useAction';

const DownloadListPage: React.FC = () => {
	const user = useSelector(selectUser);
	const downloadedItems = useSelector(selectDownloadedItems);
	const downloadStatus = useSelector(selectDownloadStatus);
	const fetchDownloadContents = useAction(fetchDownloadContentsAction);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	useEffect(() => {
		if (user?.id) {
			fetchDownloadContents();
		}
	}, [user?.id]);

	return <MyDownloads downloadStatus={downloadStatus} downloadedItems={downloadedItems} />;
};

export default DownloadListPage;
